
export { APP_ROLES } from "./Constant";
export const parseJson = (obj) => {
    try {
        if(typeof obj =="string")return JSON.parse(obj ?? "{}");
        return obj;
    } catch (error) {
        return false;
    }
}

export const pageSizeList=[
    10,15,20,25,50
]

export const convertDate = (date) => {
    try {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
    } catch (error) {
        return date;
    }
};

export const downloadFile=async(blob,fileName)=>{
    try {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        
    }
}

export const transformText = (text, type) => {
  if (!text) return text;

  switch (type) {
    case "uppercase":
      return text.toUpperCase();

    case "lowercase":
      return text.toLowerCase();

    case "capitalize":
      return text.replace(/\b\w/g, (c) => c.toUpperCase());

    default:
      return text;
  }
  
};